export type DetalheProdutoCupom = {
    descricao: string;
    valor: any;
    observacao: boolean;
};

export type ProdutoCupomNormalizado = {
    descricaoPrincipal: string;
    valorPrincipal: any;
    detalhes: DetalheProdutoCupom[];
};

export function deveExibirCategoriaNoCupom(configuracao: any, pedido?: any): boolean {
    // Pedidos importados armazenam o nome do produto em categoria e o preço-base em valor.
    return pedido?.pedidoIfood === true
        || pedido?.pedido99Food === true
        || configuracao?.exibirCategoriaNoCupom !== false;
}

export function normalizarProdutoCupom(
    produto: any,
    exibirCategoria: boolean = true
): ProdutoCupomNormalizado {
    const descricoes = Array.isArray(produto?.descricao) ? produto.descricao : null;

    if (!descricoes) {
        return {
            descricaoPrincipal: String(produto?.descricao || produto?.nome || 'Item'),
            valorPrincipal: produto?.valor,
            detalhes: []
        };
    }

    const detalhesNormalizados = descricoes.map((item: any) => ({
        descricao: String(item?.descricao || '').trim(),
        valor: item?.valor,
        observacao: item?.categoria === 'Observação'
    }));
    const detalhes = detalhesNormalizados.filter((item: DetalheProdutoCupom) => item.descricao);

    if (produto?.tipo === 'pizzas') {
        const quantidadeSabores = Number(produto?.quantidadeSabores) || 0;
        // Pizzas mantêm o layout original de tamanho e sabores, independentemente do toggle.
        return {
            descricaoPrincipal: `${produto?.tamanho || ''} ${quantidadeSabores} ${quantidadeSabores === 1 ? 'SABOR' : 'SABORES'}`.trim(),
            valorPrincipal: produto?.valor,
            detalhes
        };
    }

    if (exibirCategoria) {
        return {
            descricaoPrincipal: String(produto?.categoria || 'Item'),
            valorPrincipal: produto?.valor,
            detalhes
        };
    }

    const [primeiroDetalhe, ...demaisDetalhes] = detalhesNormalizados;
    if (!primeiroDetalhe?.descricao) {
        return {
            descricaoPrincipal: 'Item',
            valorPrincipal: produto?.valor,
            detalhes: demaisDetalhes.filter((item: DetalheProdutoCupom) => item.descricao)
        };
    }

    return {
        descricaoPrincipal: primeiroDetalhe.descricao,
        valorPrincipal: primeiroDetalhe.valor,
        detalhes: demaisDetalhes.filter((item: DetalheProdutoCupom) => item.descricao)
    };
}
